import { render, staticRenderFns } from "./labelSettings.vue?vue&type=template&id=690425da"
import script from "./labelSettings.vue?vue&type=script&lang=js"
export * from "./labelSettings.vue?vue&type=script&lang=js"
import style0 from "./labelSettings.vue?vue&type=style&index=0&id=690425da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports